import {
  BooleanQueryEntity,
  EntityQuery,
  FilterQueryEntity,
  QueryOperatorEntity,
  SectionEntity,
} from '~/types/OpenSearch';

export const testIsFilter = (
  queryEntity: EntityQuery,
): queryEntity is FilterQueryEntity => queryEntity.type === 'filter';

export const testIsSection = (
  queryEntity: EntityQuery,
): queryEntity is SectionEntity => queryEntity.type === 'section';

export const testIsBooleanTextSearch = (
  queryEntity: EntityQuery,
): queryEntity is BooleanQueryEntity => queryEntity.type === 'bool_text_search';

export const testIsOperator = (
  queryEntity: EntityQuery,
): queryEntity is QueryOperatorEntity => queryEntity.type === 'operator';
